
import { Order } from "./Order";

  export interface IOrderPdf {
    operation: string, 
    templateId: string, 
    filename: string,
    data : Order | undefined
  }  


export class OrderPdf implements IOrderPdf {
  constructor(from?: Partial<OrderPdf>) {
    (this.operation = from?.operation ?? "generate");
    (this.templateId = from?.templateId ?? "fp131-order");
    (this.filename = from?.filename ?? "test");
    (this.data = from?.data ?? undefined);
  }
  operation: string;
  templateId: string;
  filename: string;
  data : Order | undefined;
}
